/**
 * ContractLineItemsEditor の明細・スケジュール操作ロジック。
 *
 * component から切り出した純粋関数群。副作用なし・framework 非依存。
 */
import type {
  ContractLineItem,
  ContractRevenueSchedule,
} from '@shared/types/contract';

/** スケジュール明細の収益合計を算出する。結果は 2 桁小数点の文字列。 */
export function sumScheduleRevenue(
  schedules: ContractRevenueSchedule[],
): string {
  const total = schedules.reduce(
    (sum, schedule) => sum + Number(schedule.revenue ?? 0),
    0,
  );
  return Number.isFinite(total) ? total.toFixed(2) : '0.00';
}

/**
 * 明細一覧の最大 sort_order の次の値を返す。
 * 空配列の場合は 0 を返す。
 */
export function nextSortOrder(items: ContractLineItem[]): number {
  return items.reduce((max, item) => Math.max(max, item.sort_order), -1) + 1;
}
